import React from "react";
import { Container } from "./styled/baths-tooltip";

function BathsTooltip({ baths, ...props }) {
  if (!baths) return props.children;
  return <Container {...props} text={baths} />;
}

export default BathsTooltip;
